import axios from "axios";

const baseURL =
  process.env.REACT_APP_BASE_URL || `${window.location.origin}/api`;
const counterURL = `https://lm.visualon.info`;

let api = {};

let counterApi = axios.create({ baseURL: counterURL });

function setAuthToken(token) {
  if (token) {
    api = axios.create({
      baseURL,
      headers: {
        Authorization: token,
      },
    });
  } else {
    api = axios.create({ baseURL });
  }
}

setAuthToken(localStorage.getItem("jwtToken"));

export const updateUser = (payload) => api.post(`/user/update`, payload);

export const updatePassword = (payload) =>
  api.post(`/password/update`, payload);
export const forgotPassword = (payload) =>
  api.post(`/password/forgot`, payload);
export const resetPassword = (payload) => api.post(`/password/reset`, payload);

export const addCid = (payload) => api.post(`/cid/add`, payload);
export const deleteCid = (payload) => api.post(`/cid/delete`, payload);
export const requestCids = () => api.get(`/cid`);

export const register = (payload) => api.post(`/register`, payload);
export const login = (payload) => api.post(`/login`, payload);

export const requestAccounts = () => api.get(`/admin/accounts`);
export const addAccount = (payload) => api.post(`/admin/accounts/new`, payload);
export const deleteAccount = (payload) =>
  api.post(`/admin/accounts/delete`, payload);

export const getChartById = (id, ts, tts) => {
  if (!ts) return api.get(`/chart/${id}/latest`);

  const params = [`ts=${ts}`];
  if (tts) params.push(`tts=${tts}`);

  return api.get(`/chart/${id}?${params.join("&")}`);
};
export const getChartCount = (id, fts, tts) =>
  api.get(
    `/chart/count/?${id ? "id=" + id + "&" : ""}${
      fts ? "fts=" + fts + "&" : ""
    }${tts ? "tts=" + tts + "&" : ""}`,
  ); // if id == all, query total count.
export const getChartDistribution = (id, fts, tts, key = "os", source) => {
  const params = [];
  if (id) params.push(`id=${encodeURIComponent(id)}`);
  if (fts) params.push(`fts=${fts}`);
  if (tts) params.push(`tts=${tts}`);
  if (key) params.push(`key=${key}`);
  if (source) params.push(`source=${source}`);
  const qs = params.length ? `?${params.join("&")}` : "";
  return api.get(`/chart/distribution/${qs}`);
};
export const getImpression = (cid, os) => counterApi.get(`/${cid}/${os}`);

export const sendCustomerSupport = (payload) =>
  api.post(`/misc/support`, payload);

const apis = {
  setAuthToken,
  updateUser,
  updatePassword,
  forgotPassword,
  resetPassword,
  addCid,
  deleteCid,
  requestCids,
  register,
  login,
  getChartById,
  getChartCount,
  getChartDistribution,
  getImpression,
  requestAccounts,
  addAccount,
  deleteAccount,
  sendCustomerSupport,
};

export default apis;
